// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"styles_menuPaper__3hN8c","menuList":"styles_menuList__3TXY5"};